export const suppliersItemCount = (state) => {
    return state.suppliers.length;
}

export const suppliersItems = (state) => {
    return state.suppliers;
}